const targets = [
	'.primary-nav .menu-item > a',
	'.site-footer .footer-details a',
	'.site-footer .footer-credit a',
	'.site-footer .footer-top-link',
	'.work-hero .crumb a',
	'.story-body a',
	'.work-copy .text a',
	'.text a',
];

function track (html) {
	const wipe = document.createElement('span');
	wipe.className = 'link-wipe';

	const trackEl = document.createElement('span');
	trackEl.className = 'link-track';

	const line = document.createElement('span');
	line.className = 'link-line';
	line.innerHTML = html;

	trackEl.dataset.text = line.textContent.replace(/\s+/g, ' ').trim();
	trackEl.append(line);
	wipe.append(trackEl);

	return wipe;
}

export default function linkWipe () {
	document.querySelectorAll(targets.join(',')).forEach((el) => {
		if (el.querySelector('.link-wipe')) return;
		if (el.closest('.action, .footer-social, [data-cursor="arrow"], [data-cursor="play"]')) return;

		const icons = [...el.children].filter((child) => child.tagName.toLowerCase() === 'svg' || child.querySelector('svg'));
		const text = [...el.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
		if (icons.length && text.length) {
			const label = text.map((node) => node.textContent).join('');
			text[0].replaceWith(track(label.replace(/[&<>]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[char]))));
			text.slice(1).forEach((node) => node.remove());
			return;
		}

		const html = el.innerHTML.trim();
		if (! html) return;
		el.replaceChildren(track(html));
	});
}